var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.46,178.19S397.26,92.68,314.61,59,171.06,44.46,121.47,89C69,136.2,75,218.11,36.4,274.45-.7,328.62,27.94,407.29,83.19,433.81c53.07,25.47,144.18-.11,182.7-18.2S380.73,432,419,423.8,519.07,308.27,449.46,178.19Z",
    style: {
      fill: "#0A4D68"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.46,178.19S397.26,92.68,314.61,59,171.06,44.46,121.47,89C69,136.2,75,218.11,36.4,274.45-.7,328.62,27.94,407.29,83.19,433.81c53.07,25.47,144.18-.11,182.7-18.2S380.73,432,419,423.8,519.07,308.27,449.46,178.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.58,452.12h3c.05-9.55.39-78.38.39-90.49,0-12.95-.39-62.23-.4-62.72a1.49,1.49,0,0,0-1.5-1.49h0a1.5,1.5,0,0,0-1.49,1.51c0,.5.4,49.76.4,62.7C435,373.74,434.63,442.63,434.58,452.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.84 309.62 453.54 299.3 477.39 304.51 457.51 293.35 478.18 289.03 453.54 287.79 480.93 267.15 449.97 282.63 467.83 252.07 444.01 279.45 452.35 239.37 436.87 276.68 435.28 235 432.11 277.47 415.21 239.95 426.95 281.04 401.68 253.48 423.77 287.39 392.5 265.08 421.79 293.35 388.63 275.23 419.01 295.73 391.53 292.15 418.21 299.7 396.85 303.26 419.01 302.48 405.91 311.21 436.87 302.87 465.84 309.62",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.46,377.11c0,2.83.12,10.76.23,17.75.09,5.81.17,11.3.17,12.91,0,1.89-.11,11.2-.22,20.21-.09,7.81-.18,15.18-.18,16.49v7.65h3v-7.65c0-1.29.09-8.66.18-16.46.11-9,.22-18.33.22-20.24,0-1.63-.08-7.13-.17-12.95-.11-7-.23-14.9-.23-17.71a74.18,74.18,0,0,0-1.22-14.18c-.61-3.07.09-11,.42-13.83a1.5,1.5,0,0,0-3-.34c-.05.43-1.21,10.6-.38,14.75A71.4,71.4,0,0,1,423.46,377.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.36,401.81s1.59-30.27,3.17-34.24,2.78-2.78,3.18-7.54.4-6.75,1.19-8.34a32.91,32.91,0,0,0,1.59-4.36l.79-3.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.54 357.25 441.24 346.93 475.77 350.9 445.2 340.98 476.56 335.42 441.24 335.42 468.62 314.78 437.66 330.26 455.52 299.7 431.71 327.08 440.04 287 424.56 324.31 422.98 282.63 419.8 325.1 407.5 286.6 414.64 328.67 392.81 297.32 411.47 335.02 382.83 316.31 409.48 340.98 379.93 328.88 406.7 343.36 378.97 340.96 405.91 347.33 387.18 351.6 406.7 350.11 393.6 358.84 424.56 350.5 453.54 357.25",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.36 425.31 442.06 414.99 476.59 418.95 446.02 409.03 477.38 403.48 442.06 403.48 469.44 382.83 438.48 398.31 456.34 367.75 432.53 395.14 440.86 355.05 425.38 392.36 423.8 350.69 420.62 393.15 408.32 354.65 415.46 396.73 393.63 365.37 412.29 403.08 383.65 384.37 410.3 409.03 380.75 396.94 407.52 411.41 379.79 409.02 406.73 415.38 388 419.65 407.52 418.16 394.42 426.89 425.38 418.56 454.36 425.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.18,391.51s-.23-6-2.77-10.16-11.77-7.16-16.62-5.08a66.9,66.9,0,0,0-7.16,3.46,54.44,54.44,0,0,1,13.62,6.47A34.34,34.34,0,0,0,57.18,391.51Z",
    style: {
      fill: "#0A4D68",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.87,394.51s-5.54-5.31-6.46-12.7,6.93-18.93,6.93-18.93a82.34,82.34,0,0,1,6.23,15.47C75.88,386.66,66.87,394.51,66.87,394.51Z",
    style: {
      fill: "#0A4D68",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.49,392.2s-1.38-6.93,1.16-11.77,9.23-4.39,15.92-2.31,8.78,2.08,8.78,2.08a99.58,99.58,0,0,1-14.55,8.08A89.16,89.16,0,0,1,77.49,392.2Z",
    style: {
      fill: "#0A4D68",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.94,417.08a.6.6,0,0,1-.6-.6v-33a.6.6,0,0,1,.6-.6.59.59,0,0,1,.59.6v33A.59.59,0,0,1,66.94,417.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.71,417.08h-.09a.6.6,0,0,1-.51-.67c.12-.83,2.91-20.39,12.38-31.25a.6.6,0,0,1,.84,0,.59.59,0,0,1,.06.84c-9.24,10.59-12.07,30.42-12.09,30.62A.6.6,0,0,1,69.71,417.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.17,416.61h0a.59.59,0,0,1-.59-.6c0-.19.09-19-11.09-27.92a.6.6,0,0,1,.75-.93c11.63,9.31,11.54,28.07,11.53,28.86A.59.59,0,0,1,64.17,416.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,416.38a.44.44,0,0,1-.16,0,.6.6,0,0,1-.42-.73,38.56,38.56,0,0,1,5.4-11.27.6.6,0,1,1,1,.7A38,38,0,0,0,74,415.94.59.59,0,0,1,73.4,416.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,407.2s-.23-6.46,2.54-7.38,5.31,1.38,7.39,2.77,4.38,2.77,4.38,6.92-1.61,11.78-1.61,11.78-2.31-7.16-6.24-10.39S77,407.2,77,407.2Z",
    style: {
      fill: "#0A4D68",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,416.61a.6.6,0,0,1-.57-.41c0-.06-1.85-5.64-6-8.95a.59.59,0,0,1-.1-.84.6.6,0,0,1,.84-.09c4.47,3.53,6.35,9.27,6.43,9.52a.61.61,0,0,1-.39.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.18,409.28s.92-4.15-1.39-7.15-7.85-2.31-10.62.92S38.48,416,38.48,416s5.54-4.39,12-4.39S57.18,409.28,57.18,409.28Z",
    style: {
      fill: "#0A4D68",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.57 452 57.15 452 47.94 421.53 84.78 421.53 75.57 452",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.83,
    y: 416.48,
    width: 37.05,
    height: 5.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.45,317.58s-.23,13-.23,19.79S260,394.68,260,394.68s-5.41,0-6.77,2.71-2.25,8.58-2.25,8.58-9.93,3.61-13.09,8.57-4.06,8.58-5,9.93-9.47,5.42-9.47,5.42,5,2.25,6.77,5.41a54,54,0,0,1,3.15,6.77s9-1.35,20.76-3.61,21.22-4.51,24.83-8.12S292,415,292,415s.91-43.77-3.61-60.92-16.46-37.84-16.46-37.84",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.45,434.31a10.72,10.72,0,0,1,.17,3.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.69,425.37S241,427,243.61,432",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.79,404.71a8.66,8.66,0,0,0-2.18-1.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.64,406.87s3.61,3.61,6.77,7.22,14.45,7.22,14.45,7.22-6.84-9.47-12.09-14.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41,429.89s-22.08-4.65-24.34-4.2-9.93,3.64-15.83,11.42c-2.51,3.31-.45,4.51,1.35,4.06s4.88-4.51,6.54-6.51c.92-1.1,6.37-3.65,6.37-3.65s-7.49,6.55-8.39,10.16-2.26,6.32-.45,7.67,4.3-3.44,4.3-3.44l4.27-6.94,5.42-4.06s-5,3.51-7.79,14.23a1.33,1.33,0,0,0,.58,1.38,2.8,2.8,0,0,0,4.22-.86c1.26-2.26,4.58-8.32,6.15-10.24,1.94-2.38,6.86-2.77,6.86-2.77s-5.14,4.09-6,6.35-1.81,7.38,0,7.83,3.83-5.7,6.44-7.68a66.3,66.3,0,0,1,6.73-3.73s5.41-.9,4.51,3.16-8.12,3.61-8.58,6.32,6.77.45,8.58.45,8.57-1.8,9-6.77S227,431.24,223.41,429.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.65,434.4a29.32,29.32,0,0,1,3-2.4,25.45,25.45,0,0,1,4.16-.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,431s2.13-2,3.13-2.18,3.83-.5,3.83-.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.6,347.75s15.77,59.92,16.7,67.24-1.36,37-1.36,37H395.81a113.76,113.76,0,0,0,2.7-24.82c0-14-9.69-98.76-11.05-103.73s-6.32-15.79-11.73-19.41-47.39-21.66-47.39-21.66l-32.49,14.44s-33,17.6-33.4,20.76,1.81,15.8,1.81,15.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.21 307.92 297.85 321.36 299.54 424.47 309.61 437.35 318.57 423.07 301.77 321.08 307.09 307.64 300.37 296.73 294.21 307.92",
    style: {
      fill: "#0A4D68",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.29 428.3 306.45 433.3 309.61 437.35 315.29 428.3",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.44 338.64 303.73 332.86 298.36 335.39 298.3 341.69 304.44 338.64",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.21 307.92 296.89 317.8 304.86 313.3 307.09 307.64 303.1 301.15 295.61 305.39 294.21 307.92",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.77 403.46 314.03 391.31 299.41 399.58 299.48 412.67 315.77 403.46",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.82 370.4 307.68 358.39 298.62 363.28 298.68 376.38 309.82 370.4",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.06 294.49 290.02 315.2 300.37 305.13 295.06 294.49",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65,234.22s.65,5.12,1.21,8.76.56,7.56.84,10.92,6.16,6.44,6.16,6.44a83.7,83.7,0,0,1-1.4,9.51c-.84,3.36-1,3.2.11,4.32s5.88,2,5.88,2,6.89,15.56,8.29,17.24,3.64,3.08,7.84,2.8,9.8-3.64,9.8-3.64l7,12.6,23-27.44s-6.72-15.39-7-22.39,1.3-18.28-.66-28.36-16.23-19-28-20.71-28.27,6.43-34.71,11.19-5.6,13.72-3.92,15.68S254.65,234.22,254.65,234.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.38 292.53 300.37 305.13 300.46 305.02 304.21 284.13 293.38 292.53",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.44,232c6.72-2.52,13.72-9.24,18.76-8.12s-.74,7.92-.18,10.16,5,3.92,7.83,4.48,3.08,3.36,3.08,6.44,2.8,5.88,4.48,3.92,1.12-10.36,6.16-10.64,4.48,10.36,3.64,14-4.48,7.56-4.48,7.56,3.17,3.17,7,2.68a33.43,33.43,0,0,1-1.41-7.16c-.28-7,1.3-18.28-.66-28.36s-16.23-19-28-20.71-28.27,6.43-34.71,11.19-5.6,13.72-3.92,15.68,5.6,1.12,5.6,1.12S264.72,234.5,271.44,232Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.14,246.9s5.88-5.32,13.16-3.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.9,251.66a16.38,16.38,0,0,0-3.92-.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.31,254.7c.63,1.15.54,2.41-.21,2.82s-1.86-.19-2.49-1.34-.54-2.42.2-2.83S279.68,253.54,280.31,254.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,244.94s-10.92,1.68-19.32,5.6c0,0,3.92,10.08,5.6,11.48s10.92.28,14-2S288.62,244.94,288.62,244.94Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.62,
    y1: 244.94,
    x2: 307.09,
    y2: 241.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.3,
    y1: 250.54,
    x2: 262.86,
    y2: 253.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.26,252.78s-7.84,1.4-12.87,3.92c0,0,3.91,9.23,5.59,10.63a20.11,20.11,0,0,0,4.48,2.52l1.4-9.51Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,255.86s2.8-3.36,6.72-2.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.68,278s7.56-.28,11.48-4.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.57,260.06s2,9.95.34,13a69.61,69.61,0,0,1-5,7.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.45 274.33 300.37 305.13 310.17 318 332.29 282.17 324.45 274.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.27,407.67H275.49a4.58,4.58,0,0,1-4.56-4.17l-2.4-27.18h27.71l-2.4,27.18A4.58,4.58,0,0,1,289.27,407.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.22,304.49c2.24,1.86,9.39,8,13,14.14,2.07,3.5,7.41,11.71,11.63,18.13a52.78,52.78,0,0,1,7.72,19.06c2.95,15.45,8.39,43.41,10.19,49.61,2.52,8.68.84,16.8-1.68,18.2s-20.44-.28-34.71-2.52-47-12.6-47-12.6-9,.84-14.56,1.12-15.4-1.68-17.36-2.8-3.91-8.12-3.91-8.12a22.07,22.07,0,0,1-3.92-3.91c-1.68-2.24-.28-6.44-.28-6.44s-1.68-3.92-.56-6.44,14.55-2.52,14.55-2.52,6.44,0,8.4,1.68,20.44,12,20.44,12l34.71,1.68s-4.2-8.68-4.48-11.76,1.68-10.08,1.68-10.92-9.52-27.15-9.8-29.67a27.34,27.34,0,0,1,2.8-17.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,380a24.22,24.22,0,0,1,4.12,3.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.59,370.31s15.85,1.56,26.66,8.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.08,404.59a20.6,20.6,0,0,0-2.24-11l-8.67-.42s-18.48-10.36-20.44-12-8.4-1.68-8.4-1.68-13.43,0-14.55,2.52.56,6.44.56,6.44-1.4,4.2.28,6.44a22.07,22.07,0,0,0,3.92,3.91s2,7,3.91,8.12,11.76,3.08,17.36,2.8,14.56-1.12,14.56-1.12,5.21,1.65,12.39,3.78A31.92,31.92,0,0,0,349.08,404.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.56,410.62a14.5,14.5,0,0,1-1.6,2.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.64,395.92a24,24,0,0,1,.75,12.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.92,394c2.16.42,3.63.77,3.63.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88,394.8s7.84-2.24,14-2.24a53.09,53.09,0,0,1,7.59.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.87,373.08c0-2,1.81-2,1.81-4s-1.81-2-1.81-4,1.81-2,1.81-4-1.81-2-1.81-4,1.81-2,1.81-4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.24,373.44c0-1.48,1.8-1.48,1.8-3s-1.8-1.48-1.8-3,1.8-1.48,1.8-3-1.8-1.48-1.8-3,1.8-1.49,1.8-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.47,373.08c0-2.31,1.8-2.31,1.8-4.62s-1.8-2.31-1.8-4.62,1.8-2.31,1.8-4.63-1.8-2.31-1.8-4.62,1.8-2.32,1.8-4.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.37,
    y: 447.5,
    width: 182.5,
    height: 4.5,
    style: {
      fill: "#9c9c9c",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.69,364H82a2.81,2.81,0,0,0-2.72,3.53L101.37,452h92.5l-22.45-85.9A2.82,2.82,0,0,0,168.69,364Z",
    style: {
      fill: "#9c9c9c",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.37,452h92.5l-14.82-56.7c-11.3,5.06-26.5,10-48.68,18.7-17.58,6.88-27.66,14.44-33.41,21.15Z",
    style: {
      fill: "#828282",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.25,
    y1: 443.7,
    x2: 190.03,
    y2: 446.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.18,
    y1: 375.38,
    x2: 187.98,
    y2: 438.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,366h75.83a2.81,2.81,0,0,1,2.72,2.09l1,3.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 465,
    y1: 452,
    x2: 477,
    y2: 452,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 452,
    x2: 455,
    y2: 452,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.22ffbf2aa5c9f92f2dfcd61f259e2c4b.svg";
export { ForwardRef as ReactComponent };